import {
  AnalyticsProductDto,
  CreateExperienceProductDto,
  DuplicateProductType,
  ExperienceProductDto,
} from "@intelligems/ig-types";
import { VariationFe } from "@intelligems/ig-types/fe-only/variations";

import { fromGqlId } from "./shopify";

export function testProductsFromGqlId<
  T extends ExperienceProductDto | AnalyticsProductDto,
>(testProducts: T[]) {
  return testProducts.map((product) => {
    return { ...product, id: fromGqlId(product.id) };
  });
}

export const testProductsToInitialDuplicateAgProducts = (
  experienceProd: CreateExperienceProductDto[],
  variations: VariationFe[]
): DuplicateProductType[] => {
  const items: DuplicateProductType[] = [];
  for (const variation of variations) {
    if (!variation.isControl) {
      for (const product of experienceProd || []) {
        items.push({
          id: `${product.id}-${variation.id}`,
          productId: product.id,
          productTitle: product.title,
          productImage: product.image,
          eventStatus: "loading",
          handle: product.handle,
          variation: {
            id: variation.id,
            name: variation.name,
            isControl: false,
            shopifyStatus: undefined,
            syncStatus: "loading",
            issues: [],
            shopifyLink: "",
          },
        });
      }
    }
  }
  return items;
};
